import { isUndefined } from 'lodash';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries -- TODO(strict-boundaries): legacy violation, remove after refactor
import { CompareContentWithRequestId, persistCompareStateToStore } from '@neptune/compare-domain';
import { SearchQueryModelConverter } from '@neptune/search-query-domain';
import { logger } from '@neptune/shared/core-logger-util';
import { getEntityShortId } from '@neptune/shared/entity-domain';
import { searchLeaderboard } from '@neptune/shared/leaderboard-domain';

async function translateCustomRunIdsToSysIds(
  projectIdentifier: string,
  customRunIds: string[],
): Promise<string[]> {
  if (customRunIds.length === 0) {
    return [];
  }

  const runEntities = await searchLeaderboard({
    projectIdentifier,
    attributesToFetch: ['sys/id'],
    experimentsOnly: false,
    query: SearchQueryModelConverter.convertSearchQueryToNql({
      criteria: customRunIds.map((id: string) => ({
        attribute: 'sys/custom_run_id',
        operator: '=',
        type: 'string',
        value: id,
      })),
      operator: 'or',
    }),
  });

  return runEntities.entries.map((run) => getEntityShortId(run));
}

async function persistCompareKeysInScissors(
  workspaceName: string,
  projectIdentifier: string,
  runIds: string[],
  experimentNames: string[],
) {
  const snipPayload: CompareContentWithRequestId = {
    workspaceName,
    projectIdentifier,
    requestId: performance.now(),
    compare: {
      runIds,
      experimentNames,
    },
  };

  const compareKeyValue = await persistCompareStateToStore(snipPayload);
  return compareKeyValue;
}

function parseCompareJSON(
  json: string | null,
): { customRunIds: string[]; experimentNames: string[] } | null {
  if (!json) {
    // eslint-disable-next-line no-console
    console.warn('Compare JSON is null or undefined');
    logger.logMessage('Compare JSON is null or undefined', { json });
    return null;
  }

  try {
    const parsed = JSON.parse(json);

    if (!isDecodedCompareParam(parsed)) {
      logger.logMessage('Invalid compare JSON format', { json });
      return null;
    }

    return {
      customRunIds: parsed.r ?? [],
      experimentNames: parsed.e ?? [],
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to parse compare JSON', e, json);
    logger.logException(e, {
      module: 'CompareRedirectUtils',
      extra: {
        json,
      },
    });
    return null;
  }
}

function isDecodedCompareParam(paramValue: any): paramValue is { r?: string[]; e?: string[] } {
  return (
    typeof paramValue === 'object' &&
    paramValue !== null &&
    (Array.isArray(paramValue.r) || isUndefined(paramValue.r)) &&
    (Array.isArray(paramValue.e) || isUndefined(paramValue.e))
  );
}

export const CompareRedirectUtils = {
  translateCustomRunIdsToSysIds,
  persistCompareKeysInScissors,
  parseCompareJSON,
};
